module.exports = __webpack_public_path__ + "img/food01.219088de.jpg";